import { CommonState } from 'common/types'
import { ChannelParams } from 'common/types/params'
import { StateKey } from 'common/utils/flipState'
import { MapStoreState } from 'common/types/state'
import { fetchChannels, fetchStoreZzim } from 'common/services/channel'
import { ExtendedChannel } from 'common/types/entities/mongo/channel'
import history, { getLocationPath } from 'common/history'

const initialState: MapStoreState = {
  channels: [],
  selectedChannel: null,
  selectedOverlapChannels: [],
}

const INIT = 'map/store/INIT'
const FETCH = 'map/store/FETCH'
const SELECT_STORE = 'map/store/SELECT_STORE'
const SET_OVERLAP_MAP_STORES = 'map/store/SET_OVERLAP_MAP_STORES'
const DESELECT = 'map/store/DESELECT'
const EMPTY = 'map/store/EMPTY'

export const initMapStores = (curState: StateKey) => {
  return {
    curState,
    type: INIT,
  }
}

export const fetchMapStores = (curState: StateKey, params: ChannelParams) => async (
  dispatch,
  getState: () => CommonState,
) => {
  const restoredState = getMapStoresFromHistoryState()
  if (restoredState) {
    const { selectedChannel } = restoredState
    if (selectedChannel) {
      selectedChannel.zzim = await fetchStoreZzim(selectedChannel._id)
    }
    dispatch({
      curState,
      state: restoredState,
      type: FETCH,
    })
    return
  }

  const storeState = await fetchChannels(params)
  dispatch({
    curState,
    state: storeState,
    type: FETCH,
  })
}

const getMapStoresFromHistoryState = (): MapStoreState => {
  if (history.location && history.location.state && history.location.state.mapStores) {
    const mapStores = history.location.state.mapStores
    history.replace(getLocationPath(location), { ...history.location.state, mapStores: null })
    return mapStores
  }
}

export const emptyMapStores = (curState: StateKey) => {
  return {
    curState,
    type: EMPTY,
  }
}

export const selectMapStore = (curState: StateKey, selectedChannel: ExtendedChannel) => {
  return {
    curState,
    selectedChannel,
    type: SELECT_STORE,
  }
}

export const setOverlapMapStores = (curState: StateKey, selectedOverlapChannels: ExtendedChannel[]) => {
  return {
    curState,
    selectedOverlapChannels,
    type: SET_OVERLAP_MAP_STORES,
  }
}

export const deselect = (curState: StateKey) => {
  return {
    curState,
    type: DESELECT,
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case INIT:
      return initialState
    case FETCH:
      return {
        ...initialState,
        ...state,
        ...action.state,
      }
    case EMPTY: {
      return {
        ...state,
        channels: [],
      }
    }
    case SELECT_STORE:
      return {
        ...state,
        selectedChannel: action.selectedChannel,
        selectedOverlapChannels: [],
      }
    case SET_OVERLAP_MAP_STORES:
      return {
        ...state,
        selectedOverlapChannels: action.selectedOverlapChannels,
        selectedChannel: null,
      }
    case DESELECT:
      return {
        ...state,
        selectedOverlapChannels: [],
        selectedChannel: null,
      }
    default:
      return state
  }
}

export default reducer
